<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <label class="title">成员注册情况统计</label>
            注册时间：<a-range-picker v-model="registerDateRange" value-format="YYYY-MM-DD" @change="dateChange" :ranges="{ '本日': [moment(), moment()], '本周': [moment().startOf('week'), moment().endOf('week')],'本月': [moment().startOf('month'), moment().endOf('month')]  }"/>
          </a-col>

          <!--<a-col :md="6" :sm="8">-->
            <!--<span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">-->
              <!--<a-button type="primary" @click="searchQuery" icon="search">查询</a-button>-->
              <!--<a-button type="" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">-->
                <!--{{ toggleSearchStatus ? '收起' : '展开' }}-->
                <!--<a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
              <!--</a>-->
            <!--</span>-->
          <!--</a-col>-->

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div style="margin-top: 5px;margin-bottom: 5px">
      <label style="margin-right: 20px">研究中心：{{centerName}}</label>
      <a-button @click="viewCenter" type="primary" icon="plus">查看全部中心</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"

        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange">
        <!--<span slot="failtype1" style="color: green">-->
          <!--不符合纳入标准-->
        <!--</span>-->
        <!--<span slot="failtype2" style="color: green">-->
          <!--符合排除标准-->
        <!--</span>-->
        <!--<span slot="failtype3" style="color: green">-->
          <!--拒绝参与项目-->
        <!--</span>-->
        <!--<span slot="failtype4" style="color: green">-->
          <!--其他原因-->
        <!--</span>-->
        <!--<span slot="filtratefail" style="color: red">-->
          <!--（终止筛选总人数）-->
        <!--</span>-->
        <span slot="filtratefail" slot-scope="text, record">
          <a-tooltip class="info-row" >
              <template slot="title">
                <div>
                  受试者拒绝参加项目：{{record.failtype3}}
                </div>
                <div>
                  其他原因：{{record.failtype4}}
                </div>
              </template>
              <div class="one-row info">
                {{text}}
              </div>
            </a-tooltip>
        </span>
        <span slot="filtratefailinex" slot-scope="text, record">
          <a-tooltip class="info-row" >
              <template slot="title">
                <div>
                  不符合纳入标准：{{record.failtype1}}
                </div>
                <div>
                  符合排除标准：{{record.failtype2}}
                </div>
              </template>
              <div class="one-row info" >
                {{text}}
              </div>
            </a-tooltip>
        </span>
      </a-table>
    </div>

  </a-card>
</template>

<script>
  import moment from 'moment';
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'

  import Vue from 'vue'
  export default {
    name: "Info",
    mixins: [JeecgListMixin],
    components: {

    },
    props:['centerId'],
    data() {
      return {
        registerDateRange:[],
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        centerName:'',
        columns: [
          {
            title: '采集员',
            align: "center",
            dataIndex: 'personrealname',
            width: 120,
          },
          {
            title: '新增注册人数',
            align: "center",
            width: 100,
            dataIndex: 'register',
          },
          {
            title: '未筛选人数',
            align: "center",
            width: 120,
            dataIndex: 'nofiltrate',
          },
          {
            title: '不符合纳排标准',
            align: "center",
            width: 120,
            dataIndex: 'filtratefailinex',
            scopedSlots: { customRender: 'filtratefailinex' },
          },
          // {
          //   title: '通过筛选',
          //   align: "center",
          //   children:[
          //     {
          //       title: '通过筛选人数',
          //       align: "center",
          //       width: 120,
          //       dataIndex: 'isfiltrate',
          //     },
          //   ],
          // },
          {
            title: '通过筛选人数',
            align: "center",
            width: 120,
            dataIndex: 'isfiltrate',
          },
          {
            title: '终止筛选人数',
            align: "center",
            width: 120,
            dataIndex: 'filtratefail',
            scopedSlots: { customRender: 'filtratefail' },
          },
          // {
          //   title: '未应答人数',
          //   align: "center",
          //   width: 120,
          //   dataIndex: 'noreplay',
          // },
          // {
          //   title: '终止筛选',
          //   children:[
          //
          //     {
          //       // title: '不符合纳入标准',
          //       align: "center",
          //       width: 120,
          //       dataIndex: 'failtype1',
          //       slots: { title: 'failtype1' },
          //     },
          //     {
          //       // title: '符合排除标准',
          //       align: "center",
          //       width: 120,
          //       dataIndex: 'failtype2',
          //       slots: { title: 'failtype2' },
          //     },
          //     {
          //       // title: '拒绝参与项目',
          //       align: "center",
          //       width: 120,
          //       dataIndex: 'failtype3',
          //       slots: { title: 'failtype3' },
          //     },
          //     {
          //       // title: '其他原因',
          //       align: "center",
          //       width: 120,
          //       dataIndex: 'failtype4',
          //       slots: { title: 'failtype4' },
          //     },
          //     {
          //       // title: '终止筛选总人数',
          //       align: "center",
          //       width: 120,
          //       dataIndex: 'filtratefail',
          //       slots: { title: 'filtratefail' },
          //     },
          //   ],
          // },
          {
            title: '应答率',
            align: "center",
            width: 100,
            dataIndex: 'resrate',
            customRender: ((text) => {
              return text+'%'
            })
          },
        ],
        url: {
          list: "/project/statistic/register/person",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      // getAction('/project/projectGroup/list',{projectId:this.projectId}).then(res=>{
      //   if(res.success){
      //     res.result.forEach(group=>{
      //       this.columns.forEach(item=>{
      //         if(item.title ==='通过筛选'){
      //           item.children.push({
      //             title: group.name,
      //             align: "center",
      //             width: 120,
      //             dataIndex: 'groupId'+group.id,
      //             customRender: ((text) => {
      //               return text || 0
      //             })
      //           })
      //           this.$set(item,'children',item.children)
      //         }
      //       })
      //     })
      //   }
      // })
      if(this.centerId){
        this.queryParam.centerId = this.centerId
        this.queryParam.projectId = this.projectId
        this.loadCenterName()
        this.loadData()
      }
    },
    watch:{
      centerId(){
        if(this.centerId){
          this.queryParam.centerId = this.centerId
          this.queryParam.projectId = this.projectId
          this.loadCenterName()
          this.loadData()
        }
      }
    },
    methods: {
      moment,
      viewCenter(){
        this.$emit('typeChange')
      },
      dateChange(){
        if(this.registerDateRange.length===0){
          this.queryParam.startDate = ''
          this.queryParam.endDate = ''
        }else {
          this.queryParam.startDate = this.registerDateRange[0]
          this.queryParam.endDate = this.registerDateRange[1]
        }
        this.loadData()
      },
      loadCenterName(){
        if(this.centerId){
          getAction('/management/center/queryById',{id:this.centerId}).then(res=>{
            if(res.success){
              this.centerName = res.result.name
            }
          })
        }
      },
    }
  }
</script>
<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
  .info{
    color: @primary-color;
  }
</style>
